import { Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { CommonModule } from "@angular/common";
import { ScrollService } from "../../services/scroll.service";
import { ThemeService } from "../../services/theme.service";
import { HugeiconsIconComponent } from "@hugeicons/angular";
import { Moon02Icon, Sun02Icon } from "@hugeicons/core-free-icons";

@Component({
  selector: "app-footer",
  standalone: true,
  imports: [RouterLink, CommonModule, HugeiconsIconComponent],
  templateUrl: "./footer.component.html",
})
export class FooterComponent {
  currentYear: number = new Date().getFullYear();
  icons = { moon: Moon02Icon, sun: Sun02Icon };

  constructor(
    private scrollService: ScrollService,
    public themeService: ThemeService
  ) {}

  scrollToTop() {
    this.scrollService.scrollToTop();
  }
}